import { render } from "./initial-estimate-flow.vue?vue&type=template&id=2b238440"
import script from "./initial-estimate-flow.vue?vue&type=script&lang=js"
export * from "./initial-estimate-flow.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/vc4a/vc4a/wp-content/themes/vc4africa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__